import LayoutWrapper from "../components/LayoutWrapper";
import HeaderBar from "../components/HeaderBar";
import { useState, useContext, useEffect } from "react";
import getCurrentSkin from "../utils/getCurrentSkin";

import Skeleton from "react-loading-skeleton";
import "react-loading-skeleton/dist/skeleton.css";
import { ThemeContext } from "../context/ThemeContext";
import axios from "axios";
import ItemCategoryMas from "../inventory/itemCategory_Mas";
import ConfirmModal from "../components/ConfirmModal";
import * as XLSX from "xlsx";
import { useNavigate } from "react-router-dom";
import { toast, ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

const OrderHistory = () => {
  const navigate = useNavigate();
  const { isDark, skin, setSkin } = useContext(ThemeContext);
  const currentSkin = getCurrentSkin(skin);
  const { baseColor, baseShade } = currentSkin;

  const [showAddForm, setShowAddForm] = useState(false);
  const [categories, setCategories] = useState([]);
  const [editCategory, setEditCategory] = useState(null);
  const [search, setSearch] = useState("");
  const [selectedCategories, setSelectedCategories] = useState([]);
  const [page, setPage] = useState(1);
  const [limit] = useState(10);
  const [totalPages, setTotalPages] = useState(1);
  const [totalCount, setTotalCount] = useState(0);
const [loading, setLoading] = useState(true);
  const [showDeleteConfirm, setShowDeleteConfirm] = useState(false);
  const buttonClass = `bg-${baseColor}-${baseShade}`;
  const hoverClass = `hover:bg-${baseColor}-700`;

  // ✅ read session values from localStorage
  const finYearId = localStorage.getItem("finYearId") || "";
  const finYear = localStorage.getItem("finYear") || "";
  const branchId = localStorage.getItem("branchId") || "";
  const branch = localStorage.getItem("branchType") || "";
  const userId = localStorage.getItem("userId") || "";

  // ✅ common headers for all backend calls
  const commonHeaders = {
    "x-finyearid": finYearId,
    "x-finyear": finYear,
    "x-branchid": branchId,
    "x-branch": branch,
    "x-userid": userId,
  };

  const fetchData = async () => {
    setLoading(true);
    try {
      const response = await axios.get("https://nissi-india.com/api/itemList", {
        params: { page, limit, search },
        headers: commonHeaders,
      });

      setCategories(Array.isArray(response.data.itemList) ? response.data.itemList : []);
      setTotalCount(response.data.totalCount || 0);
      setTotalPages(Math.ceil((response.data.totalCount || 0) / limit) || 1);
    } catch (error) {
      console.error("Error fetching item categories:", error);
      setCategories([]);
      setTotalCount(0);
      toast.error("Failed to fetch categories!");
    } finally {
      setLoading(false);
    }
  };

useEffect(() => {
    fetchData();
  }, [page, search]);

 const confirmDeleteSelected = async () => {
    setShowDeleteConfirm(false);
    let successCount = 0;
    let failCount = 0;

    try {
      for (const cat of selectedCategories) {
        const id = cat.fld_itemcategoryid;

        if (!id) {
          console.error("No ID found for category:", cat);
          toast.error(`Category ${cat.fld_itemCategoryCode} missing ID! Skipping.`);
          failCount++;
          continue;
        }

        try {
          await axios.delete(`https://nissi-india.com/api/itemDelete/${id}`, {
            headers: commonHeaders,
          });
          successCount++;
        } catch (error) {
          console.error(`Failed deleting category ID ${id}`, error);
          const serverMsg = error.response?.data?.message;

          toast.error(
            serverMsg
              ? `${cat.fld_itemCategoryCode}: ${serverMsg}`
              : `Error deleting category ${cat.fld_itemCategoryCode}. Skipping.`
          );
          failCount++;
        }
      }

      setSelectedCategories([]);
      fetchData();

      if (successCount > 0 && failCount === 0) {
        toast.success("Selected categories removed successfully!");
      } else if (successCount > 0 && failCount > 0) {
        toast.info(`${successCount} removed, ${failCount} failed.`);
      }
    } catch (error) {
      console.error("Failed to remove categories:", error);
      toast.error("Error removing categories. Please try again.");
    }
  };
  
  
  return (
    <LayoutWrapper>
      <HeaderBar
        title={<span className="font-dmserif text-3xl">Order History</span>}
        setSkin={setSkin}
        currentSkin={skin}
      />

      <div
        className={`font-roboto-slab p-6 rounded-2xl shadow-xl border mt-6 ${
          isDark
            ? "bg-gradient-to-br from-white/20 to-white/5 backdrop-blur-md border-white/10 text-white"
            : `bg-gray-200 ${currentSkin.glass} text-black`
        }`}
      >
        <div className="flex flex-col md:flex-row items-start md:items-center justify-between mb-4 gap-4">
          <h2 className="text-2xl font-semibold dark:text-black-200"></h2>

          <div className="flex flex-col sm:flex-row items-stretch gap-3 w-full sm:w-auto">
            <input
              type="text"
              value={search}
              onChange={(e) => {
                setSearch(e.target.value);
                setPage(1);
              }}
              placeholder="Search Categories..."
              className={`px-4 py-2 rounded-lg text-sm placeholder:text-gray-500 focus:outline-none focus:ring-2 focus:ring-blue-400 ${
                isDark
                  ? "bg-gray-800/30 text-gray-200 border-white/20"
                  : "bg-white text-black border-gray-300"
              }`}
            />

            <button
              onClick={() => {
                setShowAddForm(!showAddForm);
                setEditCategory(null);
              }}
              className={`px-4 py-2 text-white text-sm rounded-lg shadow transition ${buttonClass} ${hoverClass}`}
            >
              + Add New
            </button>
          </div>
        </div>

    

        <div className="overflow-x-auto">
          <table
            className={`w-full text-sm text-left border border-gray-300 rounded-xl overflow-hidden font-roboto-slab ${
              isDark ? "text-gray-200 bg-white/10" : "text-black bg-white"
            }`}
          >
            <thead className={`text-xs uppercase text-white bg-${baseColor}-${baseShade} shadow-sm`}>
              <tr>
                <th className="px-4 py-3 border-b border-gray-300">S.No</th>
                <th className="px-4 py-3 border-b border-gray-300">Category Code & Name</th>
                <th className="px-4 py-3 border-b border-gray-300">Remarks</th>
                <th className="px-4 py-3 border-b border-gray-300">Add SubCategory</th>
                <th className="px-4 py-3 border-b border-gray-300">Edit</th>
                <th className="px-4 py-3 border-b border-gray-300">Select</th>
              </tr>
            </thead>

            <tbody className="divide-y divide-gray-300">
              {loading ? (
                [...Array(limit)].map((_, idx) => (
                  <tr key={idx}>
                    {[...Array(6)].map((_, cell) => (
                      <td key={cell} className="px-4 py-3 border-b border-gray-200">
                        <Skeleton height={20} />
                      </td>
                    ))}
                  </tr>
                ))
              ) : categories.length === 0 ? (
                <tr>
                  <td colSpan={6} className="text-center py-6 text-gray-500">
                    No item categories found.
                  </td>
                </tr>
              ) : (
                categories.map((cat, idx) => (
                  <tr
                    key={cat.fld_itemcategoryid || idx}
                    className={`${!isDark ? "hover:bg-gray-50" : "hover:bg-white/5"} transition`}
                  >
                    <td className="px-4 py-3 border-b border-gray-200">
                      {(page - 1) * limit + idx + 1}
                    </td>
                    <td className="px-4 py-3 border-b border-gray-200 font-medium">
                      {cat.fld_itemCategoryCode} ({cat.fld_itemcategory_name})
                    </td>
                    <td className="px-4 py-3 border-b border-gray-200">{cat.fld_remarks || "-"}</td>
                    <td className="px-4 py-3 border-b border-gray-200">
                      <button
                        className="text-blue-600 hover:underline"
                        onClick={() =>
  navigate("/inventory/ItemSubCategoryMaster", {
    state: {
      parentCategory: {
        fld_itemcategoryid: cat.fld_itemcategoryid,
        fld_itemCategoryCode: cat.fld_itemCategoryCode,
        fld_itemcategory_name: cat.fld_itemcategory_name,
      },
    },
  })
}
                      >
                        Add Subcategory
                      </button>
                    </td>
                    <td className="px-4 py-3 border-b border-gray-200">
                      <button
                        className="text-yellow-500 hover:text-yellow-600"
                        onClick={() => {
                          setEditCategory(cat);
                          setShowAddForm(true);
                        }}
                      >
                        ✏️
                      </button>
                    </td>
                    <td className="px-4 py-3 border-b border-gray-200 text-center">
                      <input
                        type="checkbox"
                        checked={selectedCategories.some(
                          (item) => item.fld_itemCategoryCode === cat.fld_itemCategoryCode
                        )}
                        onChange={(e) => {
                          if (e.target.checked) {
                            setSelectedCategories((prev) => [...prev, cat]);
                          } else {
                            setSelectedCategories((prev) =>
                              prev.filter(
                                (item) => item.fld_itemCategoryCode !== cat.fld_itemCategoryCode
                              )
                            );
                          }
                        }}
                        className="w-4 h-4 text-blue-600 border-gray-300 rounded focus:ring-blue-400"
                      />
                    </td>
                  </tr>
                ))
              )}
            </tbody>
          </table>

         <button
              disabled={selectedCategories.length === 0}
              onClick={() => {
                if (selectedCategories.length === 0) return;
                setShowDeleteConfirm(true);
              }}
              className={`px-4 py-2 text-white text-sm rounded-lg shadow transition ${buttonClass} ${hoverClass} ${
                selectedCategories.length === 0 ? "opacity-50 cursor-not-allowed" : ""
              }`}
            >
              🗑 Remove
            </button>
        </div>

        <div className="flex flex-col md:flex-row items-center justify-between mt-6 gap-4">
          <div className={`text-sm ${isDark ? "text-gray-300" : "text-gray-700"}`}>
            Showing{" "}
            <span className="font-semibold">{totalCount === 0 ? 0 : (page - 1) * limit + 1}</span> to{" "}
            <span className="font-semibold">{Math.min(page * limit, totalCount)}</span> of{" "}
            <span className="font-semibold">{totalCount}</span> results
          </div>

          {loading ? (
            <div className="flex space-x-2">
              <Skeleton width={80} height={36} borderRadius={12} />
              <Skeleton width={32} height={36} borderRadius={12} />
              <Skeleton width={32} height={36} borderRadius={12} />
              <Skeleton width={80} height={36} borderRadius={12} />
            </div>
          ) : (
            <div className="inline-flex rounded-lg shadow-sm overflow-hidden border border-gray-300 dark:border-gray-700 bg-white dark:bg-gray-900 font-sans">
              <button
                onClick={() => setPage((prev) => Math.max(prev - 1, 1))}
                disabled={page === 1}
                className={`px-4 py-2 text-sm font-medium ${
                  page === 1
                    ? "text-gray-400 cursor-not-allowed"
                    : "hover:bg-gray-100 dark:hover:bg-gray-800 text-gray-700 dark:text-gray-200"
                }`}
              >
                Prev
              </button>

              {[...Array(totalPages)].map((_, idx) => (
                <button
                  key={idx}
                  onClick={() => setPage(idx + 1)}
                  className={`px-4 py-2 text-sm font-medium transition ${
                    page === idx + 1
                      ? `bg-${baseColor}-${baseShade} text-white`
                      : `hover:bg-${baseColor}-100 text-gray-700 dark:hover:bg-${baseColor}-800 dark:text-gray-200`
                  }`}
                >
                  {idx + 1}
                </button>
              ))}

              <button
                onClick={() => setPage((prev) => Math.min(prev + 1, totalPages))}
                disabled={page === totalPages}
                className={`px-4 py-2 text-sm font-medium ${
                  page === totalPages
                    ? "text-gray-400 cursor-not-allowed"
                    : "hover:bg-gray-100 dark:hover:bg-gray-800 text-gray-700 dark:text-gray-200"
                }`}
              >
                Next
              </button>
            </div>
          )}
        </div>

<ToastContainer
          position="top-right"
          autoClose={3000}
          hideProgressBar={false}
          closeOnClick
          pauseOnHover
          theme={isDark ? "dark" : "light"}
          style={{ top: "90px", zIndex: 99999 }}
        />
      </div>

      {showAddForm && (
        <div className="fixed inset-0 z-50 flex items-center justify-center p-4 bg-black/50 backdrop-blur-sm">
          <div className="w-full max-w-2xl max-h-[90vh] overflow-y-auto rounded-2xl">
            <ItemCategoryMas
              editData={editCategory}
              onSuccess={() => {
                toast.success("Category saved successfully!");
                setShowAddForm(false);
                setEditCategory(null);
                fetchData();
              }}
              onCancel={() => {
                setShowAddForm(false);
                setEditCategory(null);
              }}
            />
          </div>
        </div>
      )}

      <ConfirmModal
        open={showDeleteConfirm}
        title="Remove Categories"
        message={`Are you sure you want to remove ${selectedCategories.length} category(ies)? This action cannot be undone.`}
        confirmLabel="Remove"
        onConfirm={confirmDeleteSelected}
        onCancel={() => setShowDeleteConfirm(false)}
      />
    </LayoutWrapper>
  );
};

export default OrderHistory;